import React from "react";
import donateBanner from "../../assets/water3.jpg"; // Replace with your image path
import "../Donate/donate.css";

function Donate() {
  return (
    <div className="donate-page">
      {/* Heading */}
      <h1 className="donate-heading">Contribute</h1>

      {/* Image and Intro Paragraph */}
      <div className="donate-intro">
        <img src={donateBanner} alt="Donate Banner" className="donate-banner" />
        <p className="intro-text">
          You can support us and contribute to our efforts in any of the ways mentioned hereunder.
          Please contact Devashish: <a href="mailto:devashishumale555@gmail.com">devashishumale555@gmail.com</a> or Ashish: 
          <a href="mailto:ashishmehare169@gmail.com">ashishmehare169@gmail.com</a> for details.
        </p>
      </div>

      {/* Donate Section */}
      <div className="donate-section">
        <h2>Donate</h2>
        <p>
        Help us make a difference by contributing in kind through books and seed indigenous plants.
        To ensure your contributions align with our needs,
        please ask for our latest wishlist.
        
        Please connect with us to further your support.
        </p>
        <p>
          Contribute financially to the day-to-day functioning of the Salaiban to:
        </p>
        <p>
          <strong>Tarunai Foundation</strong><br />
          Bank of Maharashtra,Khamgaon, Khamgaon Branch<br />
          Account No:20125237995<br />
          IFSC Code: <strong>MAHB0000046</strong> (please note – zero after B)
        </p>
        <p>
          Donations are eligible for Income Tax benefits under Section 80G.
        </p>
      </div>
    </div>
  );
}

export default Donate;
